import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, Input, output, Output, TemplateRef, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
    DxButtonModule,
    DxPopupComponent,
    DxPopupModule,
    DxToolbarModule,
    DxValidationGroupComponent,
    DxValidationGroupModule,
} from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import { ApplyPipe } from 'src/app/pipes/apply.pipe';
import { ScreenService } from 'src/app/shared/services';
import { IFooterButton } from 'src/app/types/footerButtons';

@Component({
    selector: 'app-form-popup',
    templateUrl: './form-popup.component.html',
    styleUrls: ['./form-popup.component.scss'],
    standalone: true,
    imports: [ApplyPipe, DxButtonModule, DxToolbarModule, DxPopupModule, DxValidationGroupModule, DxTemplateModule, CommonModule, TranslocoPipe],
})
export class FormPopupComponent {
    protected screen = inject(ScreenService);
    @ViewChild('validationGroup', { static: true }) validationGroup: DxValidationGroupComponent | undefined;

    @ViewChild(DxPopupComponent, { static: true }) private popup: DxPopupComponent | undefined;

    @Input() titleText = '';

    // Angular template for the popup title content
    @Input() titleTemplate?: TemplateRef<unknown>;

    @Input() width: string | number = 480;

    @Input() maxWidth: string | number;

    @Input() height: string | number = 'auto';
    @Input() maxHeight: string | number = '';

    @Input() wrapperAttr: Record<string, string> = {};

    @Input() visible = false;

    @Input() isSaveDisabled = false;

    @Output() save = new EventEmitter();

    @Output() visibleChange = new EventEmitter<boolean>();

    footerButtons = input<IFooterButton[]>([]);
    clicked = output<string>();
    closed = output<void>();

    isValid() {
        return this.validationGroup?.instance.validate().isValid;
    }

    onSaveClick() {
        if (!this.isValid()) {
            return;
        }

        this.save.emit();
        // this.close();
    }

    close() {
        this.validationGroup?.instance.reset();
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.closed.emit();
    }

    getWrapperAttrs = (inputWrapperAttr: Record<string, string>) => {
        return {
            ...inputWrapperAttr,
            class: `${inputWrapperAttr['class']} form-popup`,
        };
    };

    onFooterButtonClick(action: string) {
        this.clicked.emit(action);
    }

    hide() {
        this.popup?.instance.hide();
    }
}
